import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { faqs } from '../data/faqs';
import { SectionHeading } from './SectionHeading';
import { TextButton } from './TextButton';
import { smsMessages } from '../utils/sms';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="border-t border-ink-950/8 bg-canvas py-20 lg:py-28" data-id="element-33" data-mp="1gjvkpbsqrhjx">
      <div className="mx-auto grid max-w-shell gap-12 px-5 sm:px-8 lg:grid-cols-[0.8fr_1.2fr] lg:gap-20" data-id="element-34" data-mp="24ahga3lk79d1">
        <div data-id="element-35" data-mp="28a9rko2c7tm3">
          <SectionHeading eyebrow="Questions" title="Answers, before you ask." lede="Still unsure about something specific to your pool? Text us a photo of your equipment pad and we'll tell you exactly what you need." data-id="element-36" data-mp="289zxope692b4" />
          <TextButton message={smsMessages.general} variant="outline" className="mt-8" data-id="element-37" data-mp="2n70tb3zhhhev">
            Text us
          </TextButton>
        </div>

        <dl className="divide-y divide-ink-950/10 border-t border-ink-950/10" data-id="element-38" data-mp="14uirjj4hylre">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.question} data-id="element-39" data-mp="1eln5qgmcm2l6" data-mpi={index}>
                <dt data-id="element-40" data-mp="1emoiqqmxcz5j">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-start justify-between gap-6 py-5 text-left" data-id="element-41" data-mp="1emy7kaw8h09n">
                    <span className="font-display text-lg font-medium leading-snug text-ink-950" data-id="element-42" data-mp="1jmat8sbdc1an">
                      {faq.question}
                    </span>
                    <span className="mt-0.5 shrink-0 text-aqua-600" data-id="element-43" data-mp="1slxxdlvhfl7e">
                      {isOpen ? <MinusIcon className="h-5 w-5" aria-hidden="true" data-id="element-44" data-mp="36q13ydol4sp" /> : <PlusIcon className="h-5 w-5" aria-hidden="true" data-id="element-45" data-mp="3udjahpimoa8b" />}
                    </span>
                  </button>
                </dt>
                {isOpen && <dd className="max-w-xl pb-6 pr-10 text-[15px] leading-relaxed text-ink-700" data-id="element-46" data-mp="238zelvztrpge">
                    {faq.answer}
                  </dd>}
              </div>;
        })}
        </dl>
      </div>
    </section>;
}